module.exports = __webpack_public_path__ + "static/media/podcast.9371a18b.svg";